import React from 'react';

import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { HelpBreadcrumbs, HelpSearchResults } from '@ergeon/help-components';

import { PAGE_PADDING_CLASSES, WIKI_TITLE } from '../constants';
import WikiMeta from '../WikiMeta';

import SearchHeading from './SearchHeading';
import useWikiSearch from './useWikiSearch';
import WikiSearchForm from './WikiSearchForm';

const describeResultCount = (count: number) => {
  if (count === 1) {
    return '1 page';
  }
  return `${count} pages`;
};

const getPageTitle = (query: string) => {
  if (!query) {
    return 'Search';
  }
  return `Search “${query}”`;
};

const WikiSearchPage = () => {
  const navigate = useNavigate();
  const { hasResults, localNodeKey, localTitle, query, search } = useWikiSearch();
  const { error, isLoading, results, retry } = search;

  return (
    <>
      <WikiMeta pageTitle={getPageTitle(query)} />
      <div className={classNames(PAGE_PADDING_CLASSES, 'mx-auto flex w-full max-w-3xl flex-col gap-6')}>
        <HelpBreadcrumbs currentTitle="Search" homeLabel={WIKI_TITLE} onNavigate={navigate} />
        <div className="flex flex-col gap-1">
          <h1 className="wrap-break-word heading-3 text-gray-900 dark:text-white">
            <SearchHeading query={query} />
          </h1>
          <p aria-live="polite" className="paragraph-2 text-gray-600 dark:text-gray-400">
            {hasResults && describeResultCount(results.length)}
          </p>
        </div>
        <WikiSearchForm initialQuery={query} localNodeKey={localNodeKey} localTitle={localTitle} />
        {query && (
          <HelpSearchResults
            error={error}
            isLoading={isLoading}
            onNavigate={navigate}
            onRetry={retry}
            query={query}
            results={results} />
        )}
      </div>
    </>
  );
};

export default WikiSearchPage;
